import request from '@/utils/request';

/** 功能开关（yaml jackpot.enabled；关则前端无导航） */
export function getJackpotFeature() {
  return request.get('/liyuan-trade/jackpot/feature');
}

/** 夺宝场次列表 */
export function listJackpotRounds(params = {}) {
  return request.get('/liyuan-trade/jackpot/rounds', params);
}

/** 场次详情（可选登录，带 myPurchases） */
export function getJackpotRound(id) {
  return request.get(`/liyuan-trade/jackpot/rounds/${id}`);
}

/** 中心化买入（零钱包弹窗） */
export function buyJackpotShares(id, { shares, clientRequestId }) {
  return request.post(`/liyuan-trade/jackpot/rounds/${id}/buy`, {
    shares,
    clientRequestId,
  });
}

/** 开奖结果 / 验算数据 */
export function getJackpotResult(id) {
  return request.get(`/liyuan-trade/jackpot/rounds/${id}/result`);
}

/** 链上对齐状态 */
export function getJackpotSyncStatus() {
  return request.get('/liyuan-trade/jackpot/sync/status');
}

/** EOA 上报对齐 tx */
export function confirmJackpotSync({ debtIds, txHash }) {
  return request.post('/liyuan-trade/jackpot/sync/confirm', { debtIds, txHash });
}
